import store from '@/store'
import * as apiContract from '@/api/contract'
import * as apiInquiry from '@/api/inquiry'
import * as apiPayment from '@/api/payment'
import * as apiQA from '@/api/qa'
import * as common from '@/util/common'
import * as CommonInquiry from '@/logic/common/CommonInquiry'

/**
 * 新規契約申し込みフォーム（入力・確認）：WEB会員セッションAPIを呼び出す
 * @param {object} group1 対象group1
 */
export const getWebSession = (group1) => {
  return apiContract.getWebSession().then((response) => {
    group1.isWebSessionFetched = true
    const { data } = response
    // const data = {
    //   status: 0,
    //   web_mem_info: {
    //     webuser_id: 'aquaring005',
    //     name: 'アクア０５',
    //     post_code: '4600008',
    //     address1: '名古屋市中区',
    //     address2: '栄',
    //     address3: '３－２８',
    //     address4: '',
    //     mail: 'aquaring005@dg-labo.net',
    //     billing_name: '個人（医療・保健・福祉他関連資格者）',
    //     occupation: '保育士',
    //     phone_code: '052-249-7700'
    //   },
    //   error_message: ''
    // }
    const status = data.status
    group1.isWebSessionValid = (status === 0)

    // WEBセッション情報取得API 未ログインの場合
    if (!group1.isWebSessionValid) {
      return
    }

    // WEBセッション情報取得API ログイン済みの場合
    group1.web_mem_info = data.web_mem_info
    store.dispatch('newApplication/setWebMemberInfo', group1.web_mem_info)
  })
}

/**
 * 新規契約申し込みフォーム（入力）：職業選択肢表示用のデータをロード
 * @param {object} group1 対象group1
 */
export const loadJobs = (group1) => {
  CommonInquiry.loadJobs(group1).then(() => {
    // すでに（storeからの復元で）設定されている場合はスキップ
    if (group1.occupation_classification && group1.occupation) {
      return
    }

    // 職業 区分を設定
    const foundOccupationClassification = group1.occupationClassificationList.find((occupationClassification) => {
      return occupationClassification.name === group1.web_mem_info.billing_name
    })
    group1.occupation_classification = foundOccupationClassification.id ?? ''

    // 職業 業種・職業を設定
    for (const item of group1.occupationClassificationList) {
      const foundOccupation = item.occupations.find((occupation) => occupation.name === group1.web_mem_info.occupation)
      if (foundOccupation) {
        group1.occupation = foundOccupation.id ?? ''
        break
      }
    }
  })
}

/**
 * 新規契約申し込みフォーム（入力）：パッケージ＆ライセンス一覧をロード
 * @param {object} group1 対象group1
 * @param {number} isTrial 0=通常
 * @param {number} isOnlyContract 0=契約商品以外も含む
 */
export const loadPackageAndLicenses = (group1, isTrial = 0, isOnlyContract = 0) => {

  // パッケージ・商品一覧APIをコール
  const params = {}
  params.is_trial = isTrial
  params.is_only_contact = isOnlyContract

  const action = (response, group1) => {
    if (response) {
      const { data } = response

      const packages = data.packages ?? []

      // 初期化
      group1.packagesAndProducts = [] // パッケージ＆商品一覧データ

      const listWork = []

      for (let i = 0; i < packages.length; i++) {
        const packageId = packages[i].package_id ?? 0
        const packageName = packages[i].name ?? ''
        const products = packages[i].products

        let isFirstProduct = true

        const productsCount = products.length ?? 0

        for (let k = 0; k < products.length; k++) {
          const map = {}
          map.is_first = isFirstProduct // 最初の商品の場合true(<th>タグの出力判定で使用)
          map.products_count = productsCount // 商品数(rowspanの値に使用)
          map.package_id = packageId
          map.package_name = packageName
          map.product_id = products[k].product_id ?? 0
          map.product_name = products[k].name ?? ''
          map.classification = products[k].classification ?? 0 // 商品区分(2=基本、3=オプション)

          // オプションライセンスの場合は基本ライセンスのfixed_licensesを入れる
          map.fixed_licenses = products[k].fixed_licenses ?? 0 // 固定ライセンス数(基本ライセンス数)
          const isOptionLicense = (map.classification === 3)
          if (isOptionLicense) {
            const basicProduct = products.find((p) => (p.classification === 2))// 対応する基本ライセンス
            map.fixed_licenses_basic = basicProduct ? (basicProduct.fixed_licenses ?? 0) : 0
          }

          map.is_bought = false // 購入フラグ
          map.licenses = products[k].fixed_licenses ?? 0 // 選択したライセンス数(初期値は固定ライセンス数)
          map.is_fixed_licenses = (map.classification === 2) // ライセンス数を固定するかどうか（2=基本=fixed_licensesの値、3=オプション=fixed_licensesの値~99）
          map.display_licenses_select = false // ライセンス数の選択肢の表示フラグ
          map.is_buyable = (map.classification === 2) // 購入可能フラグ(初期は2=基本商品のみ購入可能)
          map.price = undefined // 価格
          map.priceDisp = '-' // 価格（表示用）
          listWork.push(map)

          isFirstProduct = false
        }
      }

      if (group1.productsLicenses.length > 0) {
        // 確認画面から遷移してきた場合(group1.productsLicensesにデータが含まれている)

        // ロードした選択した商品＆ライセンス数のリストの購入状態を反映する
        let prevBasicProduct
        for (let i = 0; i < listWork.length; i++) {

          const classification = listWork[i].classification
          if (classification === 2) {
            // 2=基本商品の場合
            prevBasicProduct = listWork[i]
          }

          let isFound = false
          for (let k = 0; k < group1.productsLicenses.length; k++) {
            if (listWork[i].product_id === group1.productsLicenses[k].id) {
              // ライセンス選択済みの商品の場合
              listWork[i].licenses = group1.productsLicenses[k].licenses
              listWork[i].is_bought = true
              listWork[i].is_buyable = true

              // 価格を取得
              getProductPrice(listWork[i].product_id, listWork[i].licenses).then((response) => {
                const { data } = response
                const status = data.status
                listWork[i].price = (status === 0) ? data.price : undefined
                listWork[i].priceDisp = (typeof listWork[i].price === 'number') ? common.breakComma(listWork[i].price) : '-'
              })
              isFound = true
              break
            }
          }

          if (!isFound) {
            if (classification === 3) {
              // ライセンス選択済みでない場合のオプション商品は
              // 基本商品が選択されている場合は、新規契約ボタンを表示する
              listWork[i].is_buyable = prevBasicProduct.is_bought
            }
          }
        }
      }

      group1.packagesAndProducts = listWork
    }
  }

  // 認証なしページの場合
  return apiQA.listPackagesAndProductsForNonAuthForAll(params)
    .then(response => {
      action(response, group1)
    }).finally(() => {
      // パッケージ・商品一覧ロード完了フラグをtrueに設定
      group1.isPackageAndLicensesLoaded = true
    })
}

/**
 * 新規契約申し込みフォーム（入力）：商品価格を取得
 * @param {string} productId 商品ID
 * @param {number} numOfLicenses ライセンス数
 */
export const getProductPrice = (productId, numOfLicenses) => {
  return apiContract.getProductPrice({ productId, numOfLicenses })
}

/**
 * 新規契約申し込みフォーム（入力）：新規契約ボタンをクリックした場合
 */
export const onBuyButonClicked = (group1, { item }) => {
  getProductPrice(item.product_id, item.licenses)
    .then((response) => {
      const { data } = response
      const status = data.status
      item.price = (status === 0) ? data.price : undefined
      item.priceDisp = (typeof item.price === 'number') ? common.breakComma(item.price) : '-'
    })
    .finally(() => {
      item.is_bought = true

      const targetPackageId = item.package_id

      if (item.classification === 2) {
        // 基本商品の場合

        // オプション商品を購入可能にする
        const listWork = group1.packagesAndProducts
        for (let i = 0; i < listWork.length; i++) {
          if (listWork[i].package_id === targetPackageId && listWork[i].classification === 3) {
            listWork[i].is_bought = false
            listWork[i].price = undefined
            listWork[i].priceDisp = '-'
            listWork[i].is_buyable = true
          }
        }
        group1.packagesAndProducts = listWork
      }

      // 選択肢を消す
      item.display_licenses_select = false
    })
}

/**
 * 新規契約申し込みフォーム（入力）：ライセンス数の選択肢をクリックした場合
 */
export const onLicensesChoicesChanged = (group1, { item, licenses }) => {

  // ライセンス数を更新
  item.licenses = licenses

  const targetPackageId = item.package_id

  // 選択肢を消す
  item.display_licenses_select = false

  getProductPrice(item.product_id, item.licenses)
    .then((response) => {
      const { data } = response
      const status = data.status
      item.price = (status === 0) ? data.price : undefined
      item.priceDisp = (typeof item.price === 'number') ? common.breakComma(item.price) : '-'
    })
}

/**
 * 新規契約申し込みフォーム（入力）：リセットボタン（消しゴムボタン）をクリックした場合
 */
export const onResetButtonClicked = (group1, { item }) => {
  item.is_bought = false
  item.price = undefined
  item.priceDisp = '-'
  item.licenses = item.fixed_licenses

  const targetPackageId = item.package_id
  if (item.classification === 2) {
    // 基本商品の場合
    // オプション商品を購入不可にする
    const listWork = group1.packagesAndProducts
    for (let i = 0; i < listWork.length; i++) {
      if (listWork[i].package_id === targetPackageId && listWork[i].classification === 3) {
        listWork[i].is_bought = false
        listWork[i].price = undefined
        listWork[i].priceDisp = '-'
        listWork[i].is_buyable = false
      }
    }
    group1.packagesAndProducts = listWork
  }
}

/**
 * 新規契約申し込みフォーム（入力）：ご請求金額合計
 */
export const calcTotalPrice = (group1) => {
  let price = 0
  for (let i = 0; i < group1.packagesAndProducts.length; i++) {
    if (group1.packagesAndProducts[i].is_bought && (group1.packagesAndProducts[i].licenses > 0) && !isNaN(group1.packagesAndProducts[i].price)) {
      price += group1.packagesAndProducts[i].price
    }
  }
  return price
}

/**
 * 新規契約申し込みフォーム（入力）：申込認証コードを取得ボタンをクリックした場合
 * @param {string} webuserId WEB会員ID
 * @param {boolean} checkError エラーチェックするかどうか
 * @returns {Promise}
 */
export const onGetOfferCode = (group1, checkError = true) => {
  const params = {
    webuser_id: group1.web_mem_info.webuser_id
  }
  return apiContract.getOfferCode(params).then((response) => {
    const { data } = response
    // const data = {
    //   status: 0,
    //   request_code: 'abcdef',
    //   pay_method: 2,
    //   message: ''
    // }
    const status = data.status
    if (status !== 0) {
      if (checkError) {
        group1.error_offerCode = data.message
      }
      return
    }
    group1.paymentMethod = Number(data.pay_method)
    group1.offerCode = data.request_code
    group1.offerCodeRequestStatus = data.request_status
    group1.error_offerCode = ''
    store.dispatch('newApplication/setOfferCode', group1.offerCode)
    store.dispatch('newApplication/setPaymentMethod', group1.paymentMethod)
  })
}

